(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.NBBBlogPopupCore = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MODEL_CATALOG = {
    Apple: [
      { name: 'Apple Watch Series 11', sizes: ['42 mm', '46 mm'] },
      { name: 'Apple Watch Series 10', sizes: ['42 mm', '46 mm'] },
      { name: 'Apple Watch Series 9', sizes: ['41 mm', '45 mm'] },
      { name: 'Apple Watch Series 8', sizes: ['41 mm', '45 mm'] },
      { name: 'Apple Watch Series 7', sizes: ['41 mm', '45 mm'] },
      { name: 'Apple Watch Ultra 3', sizes: ['49 mm'] },
      { name: 'Apple Watch Ultra 2', sizes: ['49 mm'] },
      { name: 'Apple Watch SE', sizes: ['40 mm', '44 mm'] }
    ],
    Fitbit: [
      { name: 'Fitbit Charge 6', sizes: ['All editions'] },
      { name: 'Fitbit Charge 5', sizes: ['All editions'] },
      { name: 'Fitbit Charge 4', sizes: ['All editions'] },
      { name: 'Fitbit Charge 3', sizes: ['All editions'] },
      { name: 'Fitbit Versa 4', sizes: ['All editions'] },
      { name: 'Fitbit Versa 3', sizes: ['All editions'] },
      { name: 'Fitbit Versa 2', sizes: ['All editions'] },
      { name: 'Fitbit Sense 2', sizes: ['All editions'] },
      { name: 'Fitbit Sense', sizes: ['All editions'] },
      { name: 'Fitbit Luxe', sizes: ['All editions'] }
    ],
    Garmin: [
      { name: 'Garmin Fēnix 8', sizes: ['43 mm', '47 mm', '51 mm'] },
      { name: 'Garmin Fēnix 7', sizes: ['42 mm', '47 mm', '51 mm'] },
      { name: 'Garmin Forerunner 970', sizes: ['47 mm'] },
      { name: 'Garmin Forerunner 965', sizes: ['47 mm'] },
      { name: 'Garmin Forerunner 265', sizes: ['46 mm'] },
      { name: 'Garmin Forerunner 165', sizes: ['43 mm'] },
      { name: 'Garmin Instinct 3', sizes: ['45 mm', '50 mm'] },
      { name: 'Garmin Instinct 2', sizes: ['40 mm', '45 mm', '50 mm'] },
      { name: 'Garmin Venu 4', sizes: ['41 mm', '45 mm'] },
      { name: 'Garmin Venu 3', sizes: ['41 mm', '45 mm'] },
      { name: 'Garmin Vívoactive 6', sizes: ['42 mm'] },
      { name: 'Garmin MARQ', sizes: ['Model-specific'] }
    ],
    Samsung: [
      { name: 'Galaxy Watch 9', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 8', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 8 Classic', sizes: ['46 mm'] },
      { name: 'Galaxy Watch Ultra 2', sizes: ['47 mm'] },
      { name: 'Galaxy Watch Ultra', sizes: ['47 mm'] },
      { name: 'Galaxy Watch 7', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 6', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 6 Classic', sizes: ['43 mm', '47 mm'] },
      { name: 'Galaxy Watch 5', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 5 Pro', sizes: ['45 mm'] },
      { name: 'Galaxy Watch 4', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 4 Classic', sizes: ['42 mm', '46 mm'] }
    ]
  };

  var MATERIALS = {
    training: 'Sweat-ready silicone + breathable nylon',
    office: 'Comfortable nylon + polished metal',
    everyday: 'Versatile nylon + soft silicone',
    style: 'Milanese, metal + leather looks'
  };

  function clean(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeEmail(value) {
    return clean(value).toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(normalizeEmail(value));
  }

  function modelsForBrand(brand, query) {
    var needle = clean(query).toLowerCase();
    return (MODEL_CATALOG[brand] || [])
      .filter(function (model) { return model.name.toLowerCase().indexOf(needle) > -1; })
      .slice(0, 8)
      .map(function (model) { return { name: model.name, sizes: model.sizes.slice() }; });
  }

  function nextStageForModel(model) {
    return model && Array.isArray(model.sizes) && model.sizes.length > 1 ? 'size' : 'usecase';
  }

  function recommendMaterial(usecase) {
    return MATERIALS[usecase] || 'Comfort-first, exact-fit options';
  }

  function brandLabel(brand) {
    if (brand === 'Apple') return 'Apple Watch';
    if (brand === 'Samsung') return 'Galaxy Watch';
    if (brand === 'Garmin' || brand === 'Fitbit') return brand;
    return 'watch';
  }

  function articleTeaserContent(articleIdentity, brandHint) {
    var identity = clean(articleIdentity).toLowerCase().replace(/[\u2013\u2014_-]+/g, ' ');
    var widthMatch = identity.match(/\b(16|18|20|22|24|26|38|40|41|42|44|45|46|47|49|51)\s*mm\b/);
    var width = widthMatch ? widthMatch[1] + ' mm' : '';
    var brandRules = [
      { key: 'Apple', label: 'Apple Watch', terms: /\b(?:apple watch|apple|iwatch)\b/ },
      { key: 'Samsung', label: 'Galaxy Watch', terms: /\b(?:samsung|galaxy watch|galaxy)\b/ },
      { key: 'Garmin', label: 'Garmin', terms: /\b(?:garmin|fenix|f\u0113nix|venu|forerunner|vivoactive|vivomove|instinct|epix|quickfit)\b/ },
      { key: 'Fitbit', label: 'Fitbit', terms: /\b(?:fitbit|versa|charge|sense|luxe)\b/ },
      { key: 'Amazfit', label: 'Amazfit', terms: /\bamazfit\b/ },
      { key: 'COROS', label: 'COROS', terms: /\bcoros\b/ },
      { key: 'Fossil', label: 'Fossil', terms: /\bfossil\b/ },
      { key: 'Huawei', label: 'Huawei Watch', terms: /\bhuawei\b/ },
      { key: 'Google', label: 'Pixel Watch', terms: /\b(?:google pixel watch|pixel watch)\b/ },
      { key: 'OnePlus', label: 'OnePlus Watch', terms: /\boneplus\b/ },
      { key: 'Polar', label: 'Polar', terms: /\bpolar\b/ },
      { key: 'Suunto', label: 'Suunto', terms: /\bsuunto\b/ },
      { key: 'TicWatch', label: 'TicWatch', terms: /\bticwatch\b/ },
      { key: 'Withings', label: 'Withings', terms: /\bwithings\b/ },
      { key: 'Xiaomi', label: 'Xiaomi Watch', terms: /\b(?:xiaomi|mi watch)\b/ }
    ];
    var hintedBrand = brandRules.find(function (rule) { return rule.key === brandHint; });
    var matchedBrands = brandRules.filter(function (rule) { return rule.terms.test(identity); });
    var brand = hintedBrand || (matchedBrands.length === 1 ? matchedBrands[0] : null);
    var connector = '';
    if (/\bquick\s*fit\b/.test(identity)) connector = 'QuickFit';
    else if (/\bquick\s*release\b/.test(identity)) connector = 'quick-release';
    if (connector && !width) {
      var connectorWidthMatch = identity.match(/\bquick\s*(?:fit|release)\s*(16|18|20|22|24|26)\b/);
      if (connectorWidthMatch) width = connectorWidthMatch[1] + ' mm';
    }

    var materialRules = [
      { key: 'nylon', label: 'nylon' },
      { key: 'leather', label: 'leather' },
      { key: 'silicone', label: 'silicone' },
      { key: 'rubber', label: 'rubber' },
      { key: 'milanese', label: 'Milanese' },
      { key: 'titanium', label: 'titanium' },
      { key: 'stainless steel', label: 'stainless steel' },
      { key: 'metal', label: 'metal' },
      { key: 'braided', label: 'braided' }
    ];
    var material = materialRules.find(function (rule) { return identity.indexOf(rule.key) > -1; });
    var isCare = /\b(?:clean|cleaning|care|wash|washing|smell|odor|odour)\b/.test(identity);
    var content = {
      kind: 'general',
      cornerTitle: 'Personal band guide',
      cornerDetail: 'Match your fit, material and use',
      inlineEyebrow: 'Free owner briefing',
      inlineHeading: 'Make this guide fit your watch.',
      inlineBody: 'Answer a few quick questions for a fit and material recommendation made for your watch.'
    };

    if (connector) {
      var connectorTopic = connector + (width ? ' ' + width.replace(' mm', '') : '');
      var connectorLabel = connector === 'QuickFit' ? connectorTopic : (width ? width + ' ' : '') + connector;
      content.kind = 'connector';
      content.cornerTitle = connectorLabel + ' guide';
      content.cornerDetail = brand ? 'Match your exact ' + brand.label + ' model' : 'Match the width to your exact watch';
      content.inlineEyebrow = 'Your ' + connectorLabel + ' owner briefing';
      content.inlineHeading = 'Make this ' + connector + ' guide fit your watch.';
      content.inlineBody = brand
        ? 'Tell us which ' + brand.label + ' you own to check ' + connectorLabel + ' compatibility and narrow down the best material for your routine.'
        : 'Tell us which watch you own to check ' + connectorLabel + ' compatibility and narrow down the best material for your routine.';
      return content;
    }

    if (brand) {
      content.kind = 'brand';
      content.cornerTitle = brand.label + (width ? ' ' + width : '') + (width ? ' guide' : ' band guide');
      content.cornerDetail = brand.key === 'Apple'
        ? 'Match your case and band style'
        : 'Match your exact ' + brand.label + ' model';
      content.inlineEyebrow = 'Your ' + brand.label + ' owner briefing';
      content.inlineHeading = 'Make this ' + brand.label + ' guide fit your watch.';
      content.inlineBody = 'Tell us which ' + brand.label + ' you own for a more useful fit and material recommendation.';
      return content;
    }

    if (material) {
      var materialTitle = material.label.charAt(0).toUpperCase() + material.label.slice(1);
      content.kind = 'material';
      content.cornerTitle = width ? width + ' ' + material.label + ' guide' : materialTitle + ' band guide';
      content.cornerDetail = material.key === 'leather'
        ? 'Match your watch and wearing style'
        : 'Check what fits your watch';
      content.inlineEyebrow = 'Your ' + (width ? width + ' ' : '') + material.label + ' band briefing';
      content.inlineHeading = 'Make this ' + material.label + ' guide fit your watch.';
      content.inlineBody = width
        ? 'Tell us which watch you own to check whether ' + width + ' fits and whether ' + material.label + ' suits how you wear it.'
        : 'Tell us which watch you own to check the fit and whether ' + material.label + ' suits how you wear it.';
      return content;
    }

    if (width) {
      content.kind = 'width';
      content.cornerTitle = width + ' band guide';
      content.cornerDetail = 'Check what fits your watch';
      content.inlineEyebrow = 'Your ' + width + ' fit briefing';
      content.inlineHeading = 'Make this fit guide fit your watch.';
      content.inlineBody = 'Tell us which watch you own to check whether ' + width + ' is the right fit before you choose a band.';
      return content;
    }

    if (isCare) {
      content.kind = 'care';
      content.cornerTitle = 'Band care guide';
      content.cornerDetail = 'Get advice for your exact watch';
      content.inlineEyebrow = 'Your band care briefing';
      content.inlineHeading = 'Make this care guide fit your watch.';
      content.inlineBody = 'Tell us which watch and band you own for more useful fit, comfort and care advice.';
    }

    return content;
  }

  function buildSignupPayload(state, context) {
    state = state || {};
    context = context || {};
    return {
      email: normalizeEmail(state.email),
      brand: clean(state.brand) || 'Other',
      model: clean(state.model),
      size: clean(state.size),
      usecase: clean(state.usecase),
      lang: clean(context.lang) || 'en',
      source: 'blog_popup_v2',
      articleHandle: clean(context.articleHandle),
      turnstileToken: clean(context.turnstileToken)
    };
  }

  function scratchedRatio(imageData, sampleStep) {
    if (!imageData || !imageData.width || !imageData.height || !imageData.data) return 0;
    var stride = Math.max(1, Math.floor(Number(sampleStep) || 1));
    var erased = 0;
    var sampled = 0;
    for (var y = 0; y < imageData.height; y += stride) {
      for (var x = 0; x < imageData.width; x += stride) {
        sampled += 1;
        if (imageData.data[(y * imageData.width + x) * 4 + 3] < 128) erased += 1;
      }
    }
    return sampled ? erased / sampled : 0;
  }

  return {
    MODEL_CATALOG: MODEL_CATALOG,
    normalizeEmail: normalizeEmail,
    isValidEmail: isValidEmail,
    modelsForBrand: modelsForBrand,
    nextStageForModel: nextStageForModel,
    recommendMaterial: recommendMaterial,
    brandLabel: brandLabel,
    articleTeaserContent: articleTeaserContent,
    buildSignupPayload: buildSignupPayload,
    scratchedRatio: scratchedRatio
  };
});
